import React from 'react';
import { BenefitType } from "../../enums/BenefitType";
import OtherBenefits from "./OtherBenefits";
import BenefitChoices from "./BenefitChoices";
import { useFormikContext } from "formik";
import { FormValues } from "../../common/FormValues";

const Benefits = () => {
    const { values } = useFormikContext<FormValues>();
    const benefit = values.benefit;

    return benefit === BenefitType.HOSPITAL_INDEMNITY ? <BenefitChoices/> : <OtherBenefits/>
};

export default Benefits;